// What an exception was raised on, said in the terms the plant uses.
//
// The evidence a rule records is written for the rule: elapsed milliseconds, a threshold in
// milliseconds, a speed to four decimal places. Printed as it is stored, it reads as
// "elapsed ms: 47752231.8334", which is a number nobody can act on and which makes a page of real
// findings look like a debug log. The figures themselves are right; only the units are wrong for
// the reader, so they are converted here and nowhere else.
const duration = (ms) => {
  const minutes = ms / 60000;
  if (minutes < 1) return `${Math.round(ms / 1000)} s`;
  // Thresholds are configured in minutes, so an hour and a half reads back as the 90 minutes
  // somebody typed rather than as 1.5 hours they would have to convert.
  if (minutes <= 120) return `${Math.round(minutes)} min`;
  const hours = minutes / 60;
  if (hours < 48) return `${hours.toFixed(1)} h`;
  return `${Math.round(hours / 24)} days`;
};

const number = (value) => (Number.isInteger(value) ? String(value) : String(Math.round(value * 100) / 100));

// A key as somebody would say it out loud: elapsedMs is how long it took, thresholdMs is the limit
// it passed. Both lose the unit from their name, because the value now carries it.
const label = (key) => key
  .replace(/Ms$/, '')
  .replace(/Kph$/, ' (km/h)')
  .replace(/Kg$/, ' (kg)')
  .replace(/([A-Z])/g, ' $1')
  .replace(/^./, (first) => first.toUpperCase())
  .trim();

export const evidenceValue = (key, value) => {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'number') return key.endsWith('Ms') ? duration(value) : number(value);
  if (typeof value === 'object') return Object.entries(value).map(([inner, held]) => `${label(inner)} ${evidenceValue(inner, held)}`).join(', ');
  return String(value);
};

/// Evidence as pairs ready to print: [["Elapsed", "13.3 h"], ["Threshold", "90 min"]].
export const evidencePairs = (evidence) => Object.entries(evidence || {}).map(([key, value]) => [label(key), evidenceValue(key, value)]);

export default evidencePairs;
